import { createEntityAdapter } from '@reduxjs/toolkit';

import type { IGrade } from '@/Module/Grade/Model/DataModel';

export const gradeAdapter = createEntityAdapter<IGrade>({
  selectId: model => model.id,
  sortComparer: (a, b) => Number(b.id) - Number(a.id),
});
